import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a price per square meter.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates when variants change on the product page.
 */
class PricePerSqm extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price per sqm display.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the updated price-per-sqm block in the fetched HTML
    // Match by data-block-id if available, otherwise by data-product-id
    const blockId = this.dataset.blockId;
    let newPricePerSqm = null;

    if (blockId) {
      // Try to find by block ID first
      newPricePerSqm = event.detail.data.html.querySelector(`[data-block-id="${blockId}"]`);
    }

    // Fallback to finding by product ID and custom element
    if (!newPricePerSqm) {
      const productId = this.dataset.productId;
      if (productId) {
        newPricePerSqm = event.detail.data.html.querySelector(
          `price-per-sqm[data-product-id="${productId}"]`
        );
      }
    }

    if (!newPricePerSqm) return;

    // Update the content using morph
    morph(this, newPricePerSqm, { childrenOnly: true });
  };
}

if (!customElements.get('price-per-sqm')) {
  customElements.define('price-per-sqm', PricePerSqm);
}

